const colors = {
  blue: '#010066',
  blueLight: '#1a1a8e',
  yellow: '#FED100',
  yellowLight: '#FFF3B0',
  white: '#ffffff',
  /** Dark page shell (lahlang-style landing) */
  pageBg: '#0c0c12',
  surface: '#13131c',
  surfaceRaised: '#1a1a26',
  borderSubtle: 'rgba(255, 255, 255, 0.08)',
  textOnDark: '#f4f4f5',
  textMuted: '#a1a1aa',
  gray50: '#f8f9fa',
  gray100: '#f0f1f3',
  gray200: '#e2e4e8',
  gray400: '#9ca3af',
  gray600: '#4b5563',
  gray800: '#1f2937',
  editorBg: '#0a0a2e',
  editorOutputBg: '#060620',
  bgColor: '#ffffff',

  primary: {
    light: '#1a1a8e',
    main: '#010066',
    dark: '#000044',
  },

  secondary: {
    light: '#FFF3B0',
    main: '#FED100',
    dark: '#e6bc00',
  },

  auxiliar: {
    info: '#82aaff',
    success: '#a5d6a7',
    warning: '#ffcb6b',
    danger: '#ff5f57',
  },

  text: {
    dark: {
      little: '#4b5563',
      medium: '#1f2937',
      very: '#111',
    },
    light: {
      little: '#9ca3af',
      medium: '#e2e8f0',
      very: '#fff',
    },
  },

  syntax: {
    keyword: '#c792ea',
    string: '#c3e88d',
    number: '#f78c6c',
    comment: '#546e7a',
    function: '#82aaff',
    operator: '#89ddff',
    builtin: '#ffcb6b',
  },
};

export default colors;
